import { render, staticRenderFns } from "./twins.vue?vue&type=template&id=7567e19a&scoped=true&"
import script from "./twins.vue?vue&type=script&lang=js&"
export * from "./twins.vue?vue&type=script&lang=js&"
import style0 from "./twins.vue?vue&type=style&index=0&id=7567e19a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567e19a",
  null
  
)

export default component.exports